import { render } from "./App.vue?vue&type=template&id=36c17dcd"
const script = {}

import "./App.vue?vue&type=style&index=0&id=36c17dcd&lang=css"
script.render = render

export default script